// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3f522703","453":"ab927858","455":"789fba89","977":"393e87da"}[chunkId] + ".chunk.js";
};